export default class Header {
    constructor() {
        const elements = document.querySelector(".js-header");

        if (elements) {
            import(/* webpackChunkName: "Header" */ "../classes/Header").then(res => {
                const Header = res.default;
                this.createInstance(Header, elements);
            });
        }
    }

    createInstance(Header, elements) {
        return new Header(elements);
    }
}
